import { useEffect, useRef } from "react";

export default function ProgressBar({ duration = 0, height = 20, color = "#4caf50", style }) {
    const fillBar = useRef();
    const animateProgressBar = (d) => {
        const progressBarFill = fillBar.current;
        const startTime = Date.now();
        const endTime = startTime + (d);

        function updateProgress() {
            const currentTime = Date.now();
            if (currentTime < endTime) {
                const progress = (currentTime - startTime) / (endTime - startTime);
                progressBarFill.style.width = `${progress * 100}%`;
                requestAnimationFrame(updateProgress); // Continue animation
            } else {
                progressBarFill.style.width = '100%'; // Ensure it reaches 100% at the end
            }
        }

        updateProgress(); // Start the animation
    }
    useEffect(() => {
        animateProgressBar(duration);
    }, [duration])
    return (
        <div className="progress-bar-container" style={{ height: `${height}px`,...style }}>
            <div className="progress-bar-fill" ref={fillBar} style={{ backgroundColor: color }}></div>
        </div>
    )
}